var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconContactUnknown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.6665,
    y: 2.08333,
    width: 13.5,
    height: 16.8333,
    rx: 1.25,
    stroke: "#B0BEC5",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 4.25H4.99992",
    stroke: "#B0BEC5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 8.41667H4.99992",
    stroke: "#B0BEC5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 12.5833H4.99992",
    stroke: "#B0BEC5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 16.75H4.99992",
    stroke: "#B0BEC5",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.38 6.19C10.78 6.19 11.1312 6.24334 11.4334 6.35C11.7445 6.45667 12.0067 6.60778 12.22 6.80334C12.4334 6.99 12.5934 7.21222 12.7 7.47C12.8067 7.71889 12.86 7.99 12.86 8.28334C12.86 8.71 12.78 9.06556 12.62 9.35C12.4689 9.62556 12.2645 9.88334 12.0067 10.1233C11.7489 10.3722 11.5134 10.6078 11.3 10.83C11.0956 11.0433 10.9934 11.2522 10.9934 11.4567C10.9934 11.6967 11.0645 11.9411 11.2067 12.19C11.2245 12.2078 11.2289 12.23 11.22 12.2567C11.2112 12.2744 11.1889 12.2833 11.1534 12.2833H9.99338C9.95783 12.2833 9.92672 12.2833 9.90005 12.2833C9.88227 12.2744 9.8556 12.2567 9.82005 12.23C9.6956 12.0878 9.61116 11.9322 9.56672 11.7633C9.52227 11.5944 9.50005 11.4433 9.50005 11.31C9.50005 10.9989 9.58894 10.7233 9.76672 10.4833C9.95338 10.2433 10.2067 9.96334 10.5267 9.64334C10.7489 9.42111 10.9178 9.23 11.0334 9.07C11.1578 8.90111 11.22 8.71445 11.22 8.51C11.22 8.27 11.1312 8.07445 10.9534 7.92334C10.7845 7.77223 10.4956 7.69667 10.0867 7.69667C9.73116 7.69667 9.4156 7.74111 9.14005 7.83C8.87338 7.91 8.62894 8.01222 8.40672 8.13667C8.3356 8.17222 8.30005 8.15445 8.30005 8.08334V6.79C8.30005 6.71889 8.31783 6.67445 8.35338 6.65667C8.51338 6.56778 8.76227 6.47 9.10005 6.36334C9.43783 6.24778 9.86449 6.19 10.38 6.19ZM10.5 15.2167C10.2245 15.2167 9.99783 15.1367 9.82005 14.9767C9.65116 14.8078 9.56672 14.5767 9.56672 14.2833C9.56672 13.9989 9.6556 13.7767 9.83338 13.6167C10.0112 13.4478 10.2334 13.3633 10.5 13.3633C10.7845 13.3633 11.0112 13.4522 11.18 13.63C11.3489 13.7989 11.4334 14.0167 11.4334 14.2833C11.4334 14.5678 11.3534 14.7944 11.1934 14.9633C11.0334 15.1322 10.8023 15.2167 10.5 15.2167Z",
    fill: "#B0BEC5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconContactUnknown);
export default __webpack_public_path__ + "static/media/icon_contact_unknown.2050777a103d5c80ab9567ab1fce65e3.svg";
export { ForwardRef as ReactComponent };